export const noOp = () => {}

export type F<T> = () => T